/**
 * Phase 28 D3: format task identifier as `#code — name` across all UI contexts.
 * Mirror of backend/src/utils/taskFormat.ts (Plan 28-04).
 *
 * Used purely for cosmetic display (dropdown items, list cells). The saved
 * entry value remains the bare task name so the existing
 * findOrCreateTask-by-name backend contract stays intact.
 */
export function formatTaskIdentifier(task: {
  code?: string | null;
  name?: string | null;
}): string {
  const code = (task.code ?? '').trim();
  const name = (task.name ?? '').trim();
  if (!code && !name) return '';
  if (!code) return name;
  if (!name) return `#${code}`;
  if (code === name) return code;
  return `#${code} — ${name}`;
}
